import { createSelector } from '../../../utils/createSelector';
export const gridDensitySelector = state => state.density;
export const gridDensityValueSelector = createSelector(gridDensitySelector, density => density.value);
export const gridDensityRowHeightSelector = createSelector(gridDensitySelector, density => density.rowHeight);
export const gridDensityHeaderHeightSelector = createSelector(gridDensitySelector, density => density.headerHeight);
export const gridDensityHeaderGroupingMaxDepthSelector = createSelector(gridDensitySelector, density => density.headerGroupingMaxDepth);
export const gridDensityFactorSelector = createSelector(gridDensitySelector, density => density.factor);
export const gridDensityTotalHeaderHeightSelector = createSelector(gridDensitySelector, density => density.headerHeight * (1 + density.headerGroupingMaxDepth));


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/density/densitySelector.js
// module id = 83
// module chunks = 25